module.exports = __webpack_public_path__ + "img/payment_callback_pic.456c8c5d.jpg";